import { TUnitTypeListingMdl } from "units/_models/UnitTypeMdl";
import { TUnitListingMdl } from "admin/units/_models/UnitListingMdl";
import { isInPesosProperty } from "_common/_utils/propertyUtils";
import { PROPERTY_TYPE, TPropertyPage } from "properties/_models/PropertyMdl";
import { TUnitHeaderPrice } from "units/UnitHeaderPrices";
import { getFees } from "_common/_utils/unitUtils";

export class UnitMapper {
    static toHeaderDetails(
        item: TUnitTypeListingMdl | TUnitListingMdl,
        markerType: "unit" | "unitType",
        property: TPropertyPage,
        numberOfFloors?: number,
    ) {
        if (markerType === "unit") {
            const unit = { ...item } as TUnitListingMdl;
            return {
                floor: unit.floor,
                bedrooms: unit.bedrooms,
                bathrooms: unit.bathrooms,
                powderRooms: unit.powderRooms,
                surface: unit.totalConstructArea,
                surfaces: {
                    interiorConstruction: unit.interiorConstruction,
                    exteriorConstruction: unit.exteriorConstruction, // old terraceSurface
                    terraceSurface: unit.terraceSurface,
                    rooftopSurface: unit.rooftopSurface,
                    yardSize: unit.yardSize,
                    poolSurface: unit.poolSurface,
                    storageSurface: unit.storageSurface,
                    parkingSurface: unit.parkingSurface,
                    totalConstructArea: unit.totalConstructArea, // old squareSurface if condo
                    lotSurface: unit.lotSurface, // old squareSurface if not condo
                    cus: unit.cus,
                    cos: unit.cos,
                },
                parking: {
                    coveredParking: unit.coveredParking,
                    garageParking: unit.garageParking,
                    outdoorParking: unit.outdoorParking,
                    streetParking: unit.streetParking,
                    undergroundParking: unit.undergroundParking,
                },
                parkingSurface: unit.parkingSurface,
                views: unit.views,
                unitType: property.type === PROPERTY_TYPE.condo ? unit.type : undefined,
                priceSurface: unit.priceSurface,
            };
        } else {
            const unitType = { ...item } as TUnitTypeListingMdl;
            return {
                numberOfFloor: numberOfFloors,
                bedrooms: unitType.bedrooms,
                bathrooms: unitType.bathrooms,
                surface: unitType.totalConstructArea?.min ?? 0,
                surfaces: {
                    interiorConstruction: unitType.interiorConstruction?.min ?? 0,
                    exteriorConstruction: unitType.exteriorConstruction?.min ?? 0,
                },
                parkingSurface: unitType.parkingSurface?.min ?? 0,
                views: unitType.views,
                unitType: item.type,
                priceSurface: 0,
                isUnitType: true,
            };
        }
    }

    static toHeaderPrice(
        item: TUnitTypeListingMdl | TUnitListingMdl,
        markerType: "unit" | "unitType",
        property: TPropertyPage,
    ): TUnitHeaderPrice {
        if (markerType === "unit") {
            const unit = { ...item } as TUnitListingMdl;
            const fees = property?.fees?.applyOnUnits ? property?.fees : unit?.fees;
            return {
                _id: unit._id,
                name: `#${unit.name}`,
                price: unit.price,
                priceInPesos: unit.priceInPesos,
                isInPesosUnit: isInPesosProperty(property),
                priceIsNotDisplayed: property.priceIsNotDisplayed,
                variant: unit.variant ?? undefined,
                phase: unit.phase ?? undefined,
                feesType: fees?.type,
                ...(fees && { feesValue: getFees(fees, unit) }),
            };
        } else {
            const unitType = { ...item } as TUnitTypeListingMdl;
            const fees = property?.fees?.applyOnUnits ? property?.fees : unitType?.fees;
            return {
                _id: unitType._id,
                name: unitType.localized.title,
                price: unitType.price.min,
                priceInPesos: unitType.priceInPesos.min,
                isInPesosUnit: isInPesosProperty(property),
                priceIsNotDisplayed: property.priceIsNotDisplayed,
                feesType: fees?.type,
                ...(fees && { feesValue: getFees(fees, unitType) }),
            };
        }
    }
}
